import {Component, EventEmitter, Input, Output} from '@angular/core';
import _ from 'lodash';

@Component({
	selector: 'collaboration-resource-info',
	templateUrl: './collaboration-resource-info.component.html'
})
export class CollaborationResourceInfoComponent {
	@Input() resource;
	@Output() closeCb = new EventEmitter<any>();

	_ = _;

	resourceTypeLabel(type: string) {
		switch (type) {
			case 'team': return 'Team';
			case 'channel': return 'Channel';
			case 'chat': return 'Chat';
			case 'site': return 'SharePoint Site';
			case 'drive': return 'OneDrive';
			case 'meeting': return 'Meeting';
			default: return type;
		}
	}
}
